// extracted by mini-css-extract-plugin
export default {"wrapper":"Prizes_wrapper__JzS2v","mainWrapper":"Prizes_mainWrapper__jswRu","loading":"Prizes_loading__AOy5X"};